export const TROUBLE_SHOOTING_DOCS_URL =
	'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
export const USAGE_LIMITS_DOCS_URL =
	'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/';
export const ACCEPTABLE_USE_POLICY_URL = 'https://www.atlassian.com/legal/acceptable-use-policy';
